<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :deleteAction="preset._id ? deleteAction : false"
        :actionButtons="!hideForm"
        size="full"
        :closeButton="hideForm"
        @shown="shown() "
        @hidden="hidden() "
    >
        <div v-if="preset">
            <div class="row align-items-center mb-2">
                <div class="col">
                    <b-form-group :label="$t('Label')">
                        <b-form-input
                            v-model="preset.label"
                            :autofocus="true"
                            :placeholder="$t('Ex.: Treatment of caries')"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group :label="$t('Specialty')">
                        <specialty-select v-model="preset.specialty" />
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Complaints')}}</div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-info"
                                        @click="openModal({ id: 'CdbModal', model: {} });"
                                    >
                                        <i class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-2">
                            <div
                                class="p-4 text-center text-muted small"
                                v-if="preset.cdb.length==0"
                            >{{$t('Nothing yet')}}</div>

                            <div class="kanban-category" tabindex="0">
                                <div class="kanban-item" tabindex="0">
                                    <draggable v-model="preset.cdb" :options="{animation:350}">
                                        <div class="card mb-1" v-for="(item, index) in preset.cdb" :key="index">
                                            <div class="card-body p-2">
                                                <div class="row align-items-center">
                                                    <div class="col-auto pointer">
                                                        <i class="fe fe-more-vertical"></i>
                                                    </div>
                                                    <div class="col-auto">
                                                        <strong>{{item.code}}</strong>
                                                    </div>
                                                    <div class="col">
                                                        {{item.label}}
                                                        <div
                                                            class="text-muted small"
                                                            v-if="item.description"
                                                        >{{ item.description}}</div>
                                                    </div>
                                                    <div class="col-auto">
                                                        <button
                                                            class="btn btn-white btn-sm mr-1"
                                                            @click="removeCdb(index)"
                                                        >
                                                            <i class="fe fe-x"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6" v-if="false">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Preliminary diagnosis')}}</div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-info"
                                        @click="openModal({ id: 'ICDModal', model: {} });"
                                    >
                                        <i class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-2">
                            <div
                                class="p-4 text-center text-muted small"
                                v-if="preset.icd.length==0"
                            >{{$t('Nothing yet')}}</div>

                            <div class="card mb-1" v-for="(item, index) in preset.icd" :key="index">
                                <div class="card-body p-2">
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <strong>{{item.code}}</strong>
                                        </div>
                                        <div class="col">{{item.label}}</div>
                                        <div class="col-auto">
                                            <button class="btn btn-white btn-sm mr-1" @click="removeDiangosis(index)">
                                                <i class="fe fe-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Objectively')}}</div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-info"
                                        @click="openModal({ id: 'OdbModal', model: {} });"
                                    >
                                        <i class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="p-4 text-center text-muted small" v-if="preset.odb.length==0">{{$t('Nothing yet')}}</div>
                        <div class="card-body p-2">
                            <div class="kanban-category" tabindex="0">
                                <div class="kanban-item" tabindex="0">
                                    <draggable v-model="preset.odb" :options="{animation:350}">
                                        <div class="card mb-1" v-for="(odbItem, index) in preset.odb" :key="index">
                                            <div class="card-body p-2">
                                                <div class="row align-items-center">
                                                    <div class="col-auto pointer">
                                                        <i class="fe fe-more-vertical"></i>
                                                    </div>
                                                    <div class="col-3">{{odbItem.label}}</div>
                                                    <div class="col">
                                                        <b-form-select multiple size="sm" v-model="odbItem.value">
                                                            <option
                                                                v-for="(item, index) in odbItem.fields"
                                                                :value="item.value"
                                                                v-b-tooltip.hover
                                                                :title="item.value"
                                                                :key="index"
                                                            >{{item.value}}</option>
                                                        </b-form-select>
                                                    </div>

                                                    <div class="col-auto">
                                                        <button
                                                            class="btn btn-white btn-sm mr-1"
                                                            @click="removeOdb(index)"
                                                        >
                                                            <i class="fe fe-x"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer p-2" v-if="preset.odb.length>=3">
                            <div class="row align-items-center m-0">
                                <div class="col"></div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-info"
                                        @click="openModal({ id: 'OdbModal', model: {} });"
                                    >
                                        <i class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Final diagnosis')}}</div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-info"
                                        @click="openModal({ id: 'ICDModalFinal', model: {} });"
                                    >
                                        <i class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-2">
                            <div
                                class="p-4 text-center text-muted small"
                                v-if="preset.icdFinal.length==0"
                            >{{$t('Nothing yet')}}</div>

                            <div class="card mb-1" v-for="(item, index) in preset.icdFinal" :key="index">
                                <div class="card-body p-2">
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <strong>{{item.code}}</strong>
                                        </div>
                                        <div class="col">{{item.label}}</div>
                                        <div class="col-auto">
                                            <button
                                                class="btn btn-white btn-sm mr-1"
                                                @click="removeDiangosisFinal(index)"
                                            >
                                                <i class="fe fe-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Treatments')}}</div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-info"
                                        @click="openModal({ id: 'TreatmentBrowserModal' });"
                                    >
                                        <i class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            class="p-4 text-center text-muted small"
                            v-if="preset.treatments.length==0"
                        >{{$t('Nothing yet')}}</div>
                        <div class="card-body p-2">
                            <treatment-loop v-model="preset.treatments"></treatment-loop>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Status localis')}}</div>
                            </div>
                        </div>

                        <div class="card-body p-2">
                            <b-form-textarea
                                id="textarea"
                                v-model="preset.statusLocalis"
                                :placeholder="$t('Ex. rinse mouth twice a day')"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Other ways of examination')}}</div>
                            </div>
                        </div>

                        <div class="card-body p-2">
                            <b-form-textarea
                                id="textarea"
                                v-model="preset.otherWaysOfExamination"
                                :placeholder="$t('Ex. rinse mouth twice a day')"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card card-inactive">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Recommendations')}}</div>
                            </div>
                        </div>

                        <div class="card-body p-2">
                            <b-form-textarea
                                id="textarea"
                                v-model="preset.recommendations"
                                :placeholder="$t('Ex. rinse mouth twice a day')"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                        </div>
                    </div>
                    <div class="card card-inactive" v-if="false">
                        <div class="card-header p-2">
                            <div class="row align-items-center m-0">
                                <div class="col">{{$t('Manipulations')}}</div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-info"
                                        @click="openModal({ id: 'ManipulationModal' });"
                                    >
                                        <i class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            class="p-4 text-center text-muted small"
                            v-if="preset.manipulations.length==0"
                        >{{$t('Nothing yet')}}</div>
                        <div class="card-body p-2">
                            <div class="card mb-1" v-for="(item, index) in preset.manipulations" :key="index">
                                <div class="card-body p-2">
                                    <div class="row align-items-center">
                                        <div class="col">{{item.label}}</div>
                                        <div class="col-auto">
                                            <button
                                                class="btn btn-white btn-sm mr-1"
                                                @click="removeManipulation(index)"
                                            >
                                                <i class="fe fe-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <odb-modal id="OdbModal" :useAction="useOdb"></odb-modal>
        <cdb-modal id="CdbModal" :useAction="useCdb"></cdb-modal>

        <i-c-d-modal id="ICDModalFinal" :useAction="useFinal"></i-c-d-modal>
        <treatment-browser id="TreatmentBrowserModal" :useAction="useTreamentAction" />
    </modal>
</template>

<script>

import Modal from "@/components/Modal.vue";
import TreatmentLoop from '@/components/TreatmentLoop';
import ICDModal from '@/components/ICD10/ICDModal.vue';
import OdbModal from '@/components/OdbModal.vue';
import CdbModal from '@/components/CdbModal.vue';
import TreatmentBrowser from '@/components/TreatmentBrowser';
import { TreatmentMixin } from '@/mixins/treatment';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import SpecialtySelect from '@/components/SpecialtySelect'
import draggable from 'vuedraggable'


export default {
    name: 'preset-form-modal',
    props: ['id', 'data'],
    mixins: [modalMixins, TreatmentMixin],
    components: {
        Modal,
        ICDModal,
        OdbModal,
        CdbModal,
        draggable,
        TreatmentLoop,
        TreatmentBrowser,
        SpecialtySelect,


    },
    data() {
        return {
            loading: false,
            hideForm: false,
            preset: {
                cdb: [],
                odb: [],
                icd: [],
                icdFinal: [],
                treatments: [],
                specialty: [],
                manipulations: [],
            },
            title: 'Preset',
        }
    },
    computed: {

    },
    mounted() {
        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        // return this.find({ query: {} }).data;
    },
    methods: {
        ...mapActions('presets', ['find', 'create', 'patch', 'remove']),

        save() {
            let promise, successMessage;
            if (this.preset._id) {
                promise = this.patch([this.preset._id, this.preset]);
                successMessage = this.$t('Preset has been updated');
            } else {
                promise = this.create(this.preset);
                successMessage = this.$t('Preset has been created');
            }

            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },
        deleteAction() {

            this.remove(this.preset._id).then(result => {
                this.$toasted.global.success({
                    message: 'Preset has been removed'
                });
            });
        },

        shown() {
            this.preset = JSON.parse(JSON.stringify({ ...this.preset, ...this.data }));
        },
        hidden() {
            this.preset = {
                cdb: [],
                odb: [],
                icd: [],
                icdFinal: [],
                treatments: [],
                manipulations: [],
            };

        },
        useManipulation(item) {
            this.preset.manipulations.push(item);
        },
        removeManipulation(index) {
            this.preset.manipulations.splice(index, 1);
        },
        removeDiangosis(index) {
            this.preset.icd.splice(index, 1);
        },
        removeDiangosisFinal(index) {
            this.preset.icdFinal.splice(index, 1);
        },
        removeCdb(index) {
            this.preset.cdb.splice(index, 1);
        },
        removeOdb(index) {
            this.preset.odb.splice(index, 1);
        },
        useCdb(item) {
            this.preset.cdb.push(item);
        },
        useOdb(item) {
            this.preset.odb.push(item);
        },
        use(item) {
            this.preset.icd.push(item);
        },
        useFinal(item) {
            this.preset.icdFinal.push(item);
        },


        useTreamentAction(item) {
            this.preset.treatments.push(item);
        },



    },

}
</script>

